import { FunctionComponent } from "react";
import InfoModal from "@components/core/modals/InfoModal";

interface PropsType {
  title: string;
}

const FormFieldTooltip: FunctionComponent<PropsType> = ({ title }) => {
  return <InfoModal value={title} info />;
};

export default FormFieldTooltip;
